/**
 * AH – Product Showcase  |  Nasalix Shopify Theme
 * File: assets/ah-showcase.js
 *
 * Static section — no storefront JS behaviour.
 * Shopify Theme Editor event handling only.
 */

(function ($) {
  'use strict';

  document.addEventListener('shopify:section:select', function (e) {
    var el = document.getElementById('ah-showcase-' + e.detail.sectionId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var sectionEl = document.getElementById('ah-showcase-' + e.detail.sectionId);
    if (!sectionEl) return;
    var blockEl = sectionEl.querySelector('[data-block-id="' + e.detail.blockId + '"]');
    if (blockEl) blockEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

})(jQuery);